// extracted by mini-css-extract-plugin
export var cardHeader = "_f6-0";
export var reorderHandle = "_f6-3";
export var titleArea = "_f6-1";
export var titleAreaWithHandle = "_f6-2";